import { Project } from '@prisma/client';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useDeleteProject } from '../../projects.queries';
import { useProjects } from '../context';
import { ProjectDeleteDialog } from './project-delete-dialog';
import { ProjectFormDialog } from './project-form-dialog';

export function ProjectsDialogs() {
  const { t } = useTranslation('projects');
  const { open, setOpen, currentRow } = useProjects();
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteProject = useDeleteProject(
    () => {
      toast.success(t('delete.toast.deleted'));
      setOpen(null);
    },
    () => {
      toast.error(t('delete.toast.deleteError'));
    }
  );

  const handleDelete = async (projectId: number) => {
    setIsDeleting(true);
    try {
      await deleteProject.mutateAsync(projectId);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleOpenChange = (open: boolean) => {
    setOpen(open ? (currentRow ? 'edit' : 'create') : null);
  };

  const handleDeleteOpenChange = (open: boolean) => {
    setOpen(open ? 'delete' : null);
  };

  if (open === 'delete' && !currentRow) return null;

  const editProject = currentRow && open === 'edit' ? (currentRow as Project) : undefined;

  return (
    <>
      <ProjectFormDialog
        open={open === 'create' || open === 'edit'}
        onOpenChange={handleOpenChange}
        mode={open === 'create' ? 'create' : 'edit'}
        currentRow={editProject}
      />
      {currentRow && (
        <ProjectDeleteDialog
          open={open === 'delete'}
          onOpenChange={handleDeleteOpenChange}
          currentRow={currentRow}
          onDelete={handleDelete}
          isDeleting={isDeleting}
        />
      )}
    </>
  );
}
